<!-- SVG trigger for chat -->
<div class="chat-icon-container">
    <!-- Chat Icon -->
    <button type="button" class="svg-trigger" (click)="toggleChat()" *ngIf="showChatButton" aria-label="Open chat" [attr.aria-expanded]="isChatVisible">
        <svg width="61" height="60.5" viewBox="0 0 122 121" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
        <g filter="url(#filter0_d_738_13558)">
          <circle cx="61" cy="56.0005" r="53" fill="url(#paint0_linear_738_13558)" />
        </g>
        <path opacity="0.4" d="M73.6982 48.3816C73.6982 58.2098 65.1652 66.1587 54.6514 66.1587L52.2896 69.003L50.8928 70.6792C49.6992 72.1014 47.4135 71.7965 46.6263 70.095L43.2232 62.6032C38.6012 59.3525 35.6045 54.1972 35.6045 48.3816C35.6045 38.5534 44.1375 30.6045 54.6514 30.6045C62.3209 30.6045 68.9492 34.8456 71.9205 40.9406C73.0634 43.2008 73.6982 45.715 73.6982 48.3816Z" fill="white" />
        <path d="M86.3956 58.1841C86.3956 63.9998 83.3989 69.1552 78.7769 72.4059L75.3739 79.8975C74.5866 81.5991 72.301 81.9293 71.1073 80.4818L67.3488 75.9612C61.203 75.9612 55.7175 73.2439 52.2891 69.0028L54.6509 66.1585C65.1647 66.1585 73.6977 58.2096 73.6977 48.3814C73.6977 45.7148 73.0628 43.2007 71.92 40.9404C80.2245 42.8451 86.3956 49.8543 86.3956 58.1841Z" fill="white" />
        <path d="M61.001 50.2859H48.3031C47.2619 50.2859 46.3984 49.4225 46.3984 48.3813C46.3984 47.34 47.2619 46.4766 48.3031 46.4766H61.001C62.0423 46.4766 62.9057 47.34 62.9057 48.3813C62.9057 49.4225 62.0423 50.2859 61.001 50.2859Z" fill="white" />
        <defs>
          <filter id="filter0_d_738_13558" x="0.712497" y="0.350487" width="120.575" height="120.575" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
            <feFlood flood-opacity="0" result="BackgroundImageFix" />
            <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
            <feOffset dy="4.6375" />
            <feGaussianBlur stdDeviation="3.64375" />
            <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.02 0" />
            <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_738_13558" />
            <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_738_13558" result="shape" />
          </filter>
          <linearGradient id="paint0_linear_738_13558" x1="82.931" y1="-9.79262" x2="36.3276" y2="138.242" gradientUnits="userSpaceOnUse">
            <stop stop-color="#926092" />
            <stop offset="1" stop-color="#532E60" />
          </linearGradient>
        </defs>
      </svg>
    </button>

    <!-- Close Button -->
    <!-- <button class="close-icon-btn" (click)="closeChatIcon()">✖</button> -->
</div>




<form [formGroup]="form">

    <!-- Chat container -->
    <div class="d-flex justify-content-center align-items-center col-xl-8 col-12 ms-0 mt-xl-0 mt-3">

        <div [ngClass]="{'visible': isChatVisible}" class="chat-container">

            <!-- Chat Header (optional, you can show this when there's a selected message or make it static) -->
            <div class="chat-header d-flex justify-content-between align-items-center">
                <div class="d-flex">
                    <div class="me-2">
                        <!-- Default header icon -->
                        <svg class="header-icon" width="46" height="46" viewBox="0 0 46 46" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <rect width="46" height="46" rx="8" fill="black" fill-opacity="0.06" />
                            <path d="M28 20C28 23.87 24.64 27 20.5 27L19.57 28.12L19.02 28.78C18.55 29.34 17.65 29.22 17.34 28.55L16 25.6C14.18 24.32 13 22.29 13 20C13 16.13 16.36 13 20.5 13C23.52 13 26.13 14.67 27.3 17.07C27.75 17.96 28 18.95 28 20Z" stroke="#532E60" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                            <path d="M32.9998 23.8603C32.9998 26.1503 31.8198 28.1803 29.9998 29.4603L28.6598 32.4103C28.3498 33.0803 27.4498 33.2103 26.9798 32.6403L25.4998 30.8603C23.0798 30.8603 20.9198 29.7903 19.5698 28.1203L20.4998 27.0003C24.6398 27.0003 27.9998 23.8703 27.9998 20.0003C27.9998 18.9503 27.7498 17.9603 27.2998 17.0703C30.5698 17.8203 32.9998 20.5803 32.9998 23.8603Z" stroke="#532E60" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                            <path d="M18 20H23" stroke="#532E60" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                        </svg>
                    </div>
                    <div>
                        <span class="fw-bold" style="font-size: 1.2rem;">
                            <ng-container *ngIf="MsgDTO?.module === 'BiddingChat'; else otherChats">
                                Bid Chat
                              </ng-container>
                              <ng-template #otherChats>
                                <ng-container *ngIf="MsgDTO?.module === 'PurchInvoiceChat'; else generalChat">
                                  Invoice Chat
                                </ng-container>
                                <ng-template #generalChat>
                                  General Chat
                                </ng-template>
                              </ng-template>
                              
                        </span> <br>
                        <span class="fw-bold" style="font-size: 0.8rem;">
                            <ng-container *ngIf="MsgDTO?.subid; else onlyId">
                                <span >{{ MsgDTO?.id }}</span> -
                        <span style="color: #D8BFD8;">{{ MsgDTO?.displayid }}</span>
                        </ng-container>
                        <ng-template #onlyId>
                            {{ MsgDTO?.id }}
                        </ng-template>
                        </span>
                    </div>
                </div>
                <!-- Close Button -->
                <button class="close-button" (click)="toggleChat()" aria-label="Close chat">
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-x-lg" viewBox="0 0 16 16" aria-hidden="true">
                        <path d="M2.146 2.146a.5.5 0 0 1 .708 0L8 7.293l5.146-5.147a.5.5 0 0 1 .708.708L8.707 8l5.147 5.146a.5.5 0 0 1-.708.708L8 8.707l-5.146 5.147a.5.5 0 0 1-.708-.708L7.293 8 2.146 2.854a.5.5 0 0 1 0-.708z"/>
                    </svg>
                </button>
            </div>

            <!-- Chat Body -->
            <div #chatBody class="chat-body d-flex flex-column align-items-end">
                <div class="col-12">
                    <!-- Show a placeholder if there are no messages -->
                    <div *ngIf="messages.length === 0" class="text-muted">
                        No messages yet. Start a conversation!
                    </div>

                    <!-- If there are messages, display them -->
                    <div *ngIf="messages.length > 0">
                        <div class="history d-flex justify-content-center">
                            <div class="px-2">
                                {{ messages[messages.length - 1]?.CreatedAt ? formatDate(messages[messages.length - 1].CreatedAt!) : '' }}
                            </div>
                        </div>

                        <div *ngFor="let message of messages" [ngClass]="{'received': message.direction?.toLowerCase() === 'Inbound'.toLowerCase(), 'sent': message.direction?.toLowerCase() === 'Outbound'.toLowerCase()}" class="chat-message mt-5">
                            <div *ngIf="message.direction?.toLowerCase() === 'Inbound'.toLowerCase()" class="message-text-rec">{{ message.messageContent }}</div>
                            <div *ngIf="message.direction?.toLowerCase() === 'Outbound'.toLowerCase()" class="message-text-sen">{{ message.messageContent }}</div>
                            <div class="text-muted small mt-1">
                                {{ message.CreatedAt ? formatDate(message.CreatedAt!) : 'Unknown time' }}
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Chat Footer (Typing input for sending a new message) -->
            <div class="chat-footer">
                <label for="chatInput" class="sr-only">Type your message</label>
                <textarea id="chatInput" class="form-control chat-input" placeholder="Type your message here..." formControlName="message" (keydown.enter)="sendMessage()" aria-label="Type your message"></textarea>
                <button id="sendButton" (click)="sendMessage()" aria-label="Send message">
          <svg width="39" height="38" viewBox="0 0 39 38" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
            <rect width="39" height="38" rx="19" fill="#532E60" />
            <path d="M15.4747 14.2668L22.9035 11.9085C26.2372 10.8501 28.0485 12.5835 26.946 15.7585L24.4697 22.8335C22.8072 27.5918 20.0772 27.5918 18.4147 22.8335L17.6797 20.7335L15.4747 20.0335C10.4785 18.4501 10.4785 15.8585 15.4747 14.2668Z" stroke="white" stroke-width="1.05882" stroke-linecap="round" stroke-linejoin="round" />
            <path d="M17.8462 20.3745L20.9787 17.3828" stroke="white" stroke-width="1.05882" stroke-linecap="round" stroke-linejoin="round" />
          </svg>
        </button>
            </div>

        </div>
    </div>


</form>